import React, { useState, useEffect } from 'react'
import axios from 'axios'
import { useForm } from 'react-hook-form';
import { useNavigate, Link } from 'react-router-dom';
import LoadingBar from 'react-top-loading-bar'

import styles from '../../App.module.css'
import classes from './VerifyEmail.module.css'

function VerifyEmail() {
    const navigate = useNavigate();
    const { register, handleSubmit, formState: { errors } } = useForm();
    const [key, setKey] = useState('');
    const [email, setEmail] = useState('');
    const [progress, setProgress] = useState(100);
    const [msg, setMsg] = useState({
        'status': '',
        'message': ''
    })

    useEffect(() => {
        let url = new URLSearchParams(window.location.search);
        let email = url.get("m");
        let key = url.get("k");
        
        setEmail(email);
        setKey(key);
    }, [])

    const sentVerifyEmail = () => {
        axios.post(`${process.env.REACT_APP_API_URL}/api/verify.php`,
        {
            key: key,
            email: email,
            action: 'VERIFY_EMAIL'
        },
        {
            headers: {
                "Content-Type": "multipart/form-data",
            }
        }).then(res => {
            console.log(res.data);
            setMsg({
                status: res.data.status,
                message: res.data.message
            })
        }).catch(err => {
            console.log(err);
        })
    }

    useEffect(() => {
        if(email && email !== '' && key && key !== '') {
            axios.post(`${process.env.REACT_APP_API_URL}/api/verify.php`,
            {
                email: email,
                key: key,
                action: 'CHECK_USER'
            },
            {
                headers: {
                "Content-Type": "multipart/form-data",
                }
            }).then(res => {
                if(res.data.status === 'success') {
                    sentVerifyEmail();
                }else {
                    navigate('/404');
                }
            })
        }
    }, [key, email])

    const onSubmit = (data) => {
        sentVerifyEmail();
    }

    return (
        <>
            <LoadingBar
                color='#f11946'
                progress={progress}
                onLoaderFinished={() => setProgress(0)}
            />
            <div className={classes.main_body}>
                <div className={classes.main_content}>
                    <div className={classes.box_wrapper}>
                        {
                            msg.status !== '' && msg.message !== '' && <div className={`alert alert-${msg.status} mb-5`} role="alert">
                                {msg.message}
                            </div>
                        }
                            
                        <div className={classes.content}>
                            <h3>Resend activation</h3>
                            <p className='text-muted'>Please activate your account via provided email! <br /> If the email doesn't arrive in your inbox, please also check the spam folders.</p>
                        </div>
                        <div className={classes.form}>
                            <form onSubmit={handleSubmit(onSubmit)}>
                                <input {...register('verify-email')} type="hidden" value="1" />
                                <input {...register('remail')} type="email" className="form-control" placeholder="Email address" value={atob(email)} readOnly={true} />
                                <div className={classes.btn}>
                                    <button className="btn btn-large btn-primary" type="submit">Resend verification</button>
                                    <Link to="/login">&lt; Back to login</Link>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default VerifyEmail